<template>
  <div class="">
    <div class="header-top-area2 pos-rel pb-15 pt-10">
      <div class="custom-container">
        <div class="row align-items-center d-flex justify-content-between">
          <div class="col-md-2 top-bar-socials">
            <div class="top-right-nav d-flex justify-content-start">
              <ul>
                <li v-for="(social, index) in socials" :key="index">
                  <a :href="social.provider_url" target="_blank" :aria-label="social.provider">
                    <svg v-if="['twitter', 'x', 'x-twitter'].includes(social.provider)" class="x-icon"
                      viewBox="0 0 24 24" aria-hidden="true">
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                    <i v-else :class="'fab fa-' + social.provider"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-10 col-lg-8 d-flex text-center top-bar-message">
            <!-- <marquee behavior="scroll" :direction="locale == 'ar' ? 'right' : 'left'" onmouseover="this.stop();"
              onmouseout="this.start();" style="color: #000; padding: 3px">
              <router-link v-for="(li, idx) in links" :key="idx" :aria-label="li.name_en" :to="'/projects/' + li.link"
                style="color: #fff; margin-left: 30px; font-weight: bold">
                &nbsp; {{ locale == "ar" ? li.name_ar : li.name_en }}&nbsp;
              </router-link>
            </marquee> -->
            <!-- <router-link v-for="(li, idx) in links" :key="idx" :aria-label="li.name_en" :to="'/projects/' + li.link"
              style="color: #fff; margin-inline: auto; font-weight: bold" class="text-center">
              &nbsp; {{ locale == "ar" ? li.name_ar : li.name_en }}&nbsp;
            </router-link> -->

            <router-link :key="links.length - 1" :aria-label="links[links.length - 1].name_en"
              :to="'/projects/' + links[links.length - 1].link"
              style="color: #fff; margin-inline: auto; font-weight: bold" class="text-center">
              &nbsp;
              {{
                locale == "ar"
                  ? links[links.length - 1].name_ar
                  : links[links.length - 1].name_en
              }}&nbsp;
            </router-link>
          </div>

          <div class="col-2 col-lg-2 top-bar-language">
            <div class="d-flex justify-content-end">
              <div class="main-menu nav-tools-icon d-md-block lang-icon">
                <ul>
                  <li>
                    <span class="lang-selector d-flex align-items-center" aria-label="language change icon">
                      <span class="d-none d-md-block" style="color: #fff">{{
                        $t("app.change_lang")
                      }}</span>
                      <i class="far fa-globe" style="color: #fff"></i>
                    </span>
                    <ul class="submenu">
                      <li>
                        <a href="javascript:;" @click="changeLang(1)" aria-label="arabic language">
                          <img src="/assets/img/ar.png" loading="lazy" />
                          {{ $t("app.arabic") }}
                        </a>
                      </li>
                      <li>
                        <a href="javascript:;" @click="changeLang(2)" aria-label="english language">
                          <img src="/assets/img/en.png" loading="lazy" />
                          {{ $t("app.english") }}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-header-area">
      <div class="custom-container">
        <div class="row align-items-center justify-content-between">
          <!-- <div
          class="col-xl-3 col-lg-3 col-md-6 col-7 d-flex align-items-center p-0"
          > -->
          <div class="hamburger-menu d-flex align-items-center col-1 d-xl-none">
            <a href="javascript:void(0);" aria-label="menu icon">
              <i class="far fa-bars"></i>
            </a>
            <div class="logo">
              <router-link :to="{ name: 'home' }" class="logo-img" aria-label="charity logo">
                <img src="/assets/img/logo/charity-logo.png" alt="charity logo" loading="lazy" />
              </router-link>
            </div>
          </div>

          <!-- <div class="logo">
            <router-link :to="{ name: 'home' }" class="logo-img" aria-label="charity logo">
              <img
                src="/assets/img/logo/charity-logo.png"
                style="aspect-ratio: 1; border-radius: 10px;"
                alt="charity logo"
                loading="lazy"
              />
            </router-link>
          </div> -->
          <!-- </div> -->

          <div class="col-xl-9 col-lg-8 d-none d-lg-block text-lg-center text-xl-right">
            <div class="main-menu d-none d-xl-block">
              <nav class="nav-items">
                <div class="logo">
                  <router-link :to="{ name: 'home' }" class="logo-img" aria-label="charity logo">
                    <img src="/assets/img/logo/charity-logo.png" alt="charity logo" loading="lazy" />
                  </router-link>
                </div>

                <ul>
                  <!-- <li>
                    <router-link class="" :to="'/'" :class="this.$route.path == '/' ? 'active' : ''">
                      {{ $t("app.home") }}
                    </router-link>
                  </li> -->
                  <li v-for="(row, index) in categories" :key="index">
                    <router-link :class="$route.params.id == row.id ? 'active' : ''"
                      :to="{ name: 'projects', params: { id: row.id } }">
                      {{ row.name }}
                    </router-link>
                    <ul v-if="row.childs.length > 0" class="submenu projectsProgress">
                      <li v-for="(subCategory, index) in row.childs" :key="index">
                        <router-link :class="$route.params.id == subCategory.id ? 'active' : ''
                          " :to="{
                            name: 'projects',
                            params: { id: subCategory.id },
                          }">
                          {{ subCategory.name }}
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <!-- <li>
                    <router-link class="" :to="'/'" :class="this.$route.path == '/' ? 'active' : ''">
                      {{ $t("app.urgent_relief") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link class="" :to="'#'" :class="this.$route.path == '/categories' ? 'active' : ''">
                      {{ $t("app.support_and_relief") }}
                    </router-link>
                    <ul class="submenu projectsProgress" style="">
                      <li>
                        <router-link class="" :to="'/notMongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.building_hospitals_and_medical_centers") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/mongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.performing_urgent_surgical_operations") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/mongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.providing_medical_equipment") }}
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <router-link class="" :to="'#'" :class="this.$route.path == '/categories' ? 'active' : ''">
                      {{ $t("app.support_and_care") }}
                    </router-link>
                    <ul class="submenu projectsProgress" style="">
                      <li>
                        <router-link class="" :to="'/notMongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.providing_medicines") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/mongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.providing_and_replacing_heart_devices") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/mongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.conducting_examinations_and_diagnosis") }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <router-link class="" :to="'#'" :class="this.$route.path == '/categories' ? 'active' : ''">
                      {{ $t("app.projects") }}
                    </router-link>
                    <ul class="submenu projectsProgress" style="">
                      <li>
                        <router-link class="" :to="'/notMongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.performing_surgical_operations") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/mongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.support_and_care_for_children_with_heart_disease") }}
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <router-link class="" :to="'/'" :class="this.$route.path == '/' ? 'active' : ''">
                      {{ $t("app.zakat_and_charity") }}
                    </router-link>
                  </li>

                  <li>
                    <router-link class="" :to="'#'" :class="this.$route.path == '/categories' ? 'active' : ''">
                      {{ $t("app.endowments") }}
                    </router-link>
                    <ul class="submenu projectsProgress" style="">
                      <li>
                        <router-link class="" :to="'/notMongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.general_sustainability_endowment") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/mongezProjects'" :class="this.$route.path == '/categories' ? 'active' : ''
                          ">
                          {{ $t("app.childrens_heart_endowment") }}
                        </router-link>
                      </li>
                    </ul>
                  </li> -->

                  <li>
                    <router-link to="/categories" :class="{ active: $route.path === '/categories' }">
                      {{ $t("app.services") }}
                    </router-link>

                    <ul class="submenu projectsProgress">
                      <li>
                        <router-link to="/projectNomination" :class="{
                          active: $route.path === '/projectNomination',
                        }">
                          {{ $t("app.design_a_project") }}
                        </router-link>
                      </li>

                      <li>
                        <router-link to="/donationVouchers" :class="{
                          active: $route.path === '/donationVouchers',
                        }">
                          {{ $t("app.dedicate_a_donation") }}
                        </router-link>
                      </li>

                      <li>
                        <router-link to="/volunteerRequest" :class="{
                          active: $route.path === '/volunteerRequest',
                        }">
                          {{ $t("app.volunteer_request") }}
                        </router-link>
                      </li>

                      <li>
                        <a href="javascript:;" data-toggle="modal" data-target="#Zakat-modal"
                          aria-label="zakah calculator" :title="$t('app.calcluate_zahat')" class="zakat-link">
                          {{ $t("app.calcluate_zahat") }}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <router-link class="" to="#" :class="this.$route.path == '/about' ? 'active' : ''">
                      {{ $t("app.about") }}
                    </router-link>
                    <ul class="submenu about">
                      <li>
                        <router-link class="" :to="'/news'" :class="this.$route.path == '/news' ? 'active' : ''">
                          {{ $t("app.news") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/achievements'" :class="this.$route.path == '/achievements' ? 'active' : ''
                          ">
                          {{ $t("app.achievements") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/about'" :class="this.$route.path == '/about' ? 'active' : ''">
                          {{ $t("app.about_us") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/contacts'" :class="this.$route.path == '/contacts' ? 'active' : ''
                          ">
                          {{ $t("app.contact_us") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/directors'" :class="this.$route.path == '/directors' ? 'active' : ''
                          ">
                          {{ $t("app.board_of_directors") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/gallery'" :class="this.$route.path == '/gallery' ? 'active' : ''
                          ">
                          {{ $t("app.gallery") }}
                        </router-link>
                      </li>
                      <li>
                        <router-link class="" :to="'/videos'" :class="this.$route.path == '/videos' ? 'active' : ''">
                          {{ $t("app.videos") }}
                        </router-link>
                      </li>
                    </ul>
                  </li>

                  <!-- <li>
                    <router-link class="" :to="'/news'" :class="this.$route.path == '/news' ? 'active' : ''">
                      {{ $t("app.news") }}
                    </router-link>
                  </li> -->

                  <!-- <li>
                        <router-link class="" :to="'/about'" :class="this.$route.path == '/about' ? 'active' : ''">
                          {{ $t("app.about") }}
                        </router-link>
                      </li> -->
                  <!-- <li>
                                                <router-link 
                                                    class="" 
                                                    :to="'/preachers'">
                                                    {{ $t('app.preachers') }}
                                                </router-link>
                                            </li> -->

                  <!-- <li>
                    <router-link
                      class=""
                      :to="'/orphans'"  
                      :class="this.$route.path == '/orphans' ? 'active' : ''"
                    >
                      {{ $t("app.orphans") }}
                    </router-link>
                  </li> -->
                  <!-- <li>
                    <router-link class="" :to="'/contacts'" :class="this.$route.path == '/contacts' ? 'active' : ''">
                      {{ $t("app.contact_us") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link class="" :to="'/projectNomination'"
                      :class="this.$route.path == '/projectNomination' ? 'active' : ''">
                      {{ $t("app.projectNomination") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link class="" :to="'/donationVouchers'"
                      :class="this.$route.path == '/donationVouchers' ? 'active' : ''">
                      {{ $t("app.donationVouchers") }}
                    </router-link>
                  </li>
                  <li>
                    <router-link class="" :to="'/volunteerRequest'"
                      :class="this.$route.path == '/volunteerRequest' ? 'active' : ''">
                      {{ $t("app.volunteerRequest") }}
                    </router-link>
                  </li> -->
                  <!-- <li
                    v-if="urgent"
                    style="padding-left: 10px; padding-right: 10px"
                  >
                    <router-link class="" :to="'/' + urgent.link">
                      {{ urgent.title }}
                    </router-link>
                  </li> -->
                </ul>
              </nav>
            </div>
          </div>

          <div class="col-xl-3 col-lg-3 col-md-3 col-7 nav-icon-section">
            <!-- Zakat Calculator icon -->
            <div class="nav-tools-icon d-md-block">
              <a class="navbar-response-action" href="javascript:;" data-toggle="modal" data-target="#Zakat-modal"
                aria-label="zakah calculator">
                <i class="fal fa-balance-scale-left" data-toggle="tooltip" data-placement="bottom"
                  :title="$t('app.calcluate_zahat')">
                </i>
              </a>
            </div>

            <!-- Zakat Calculator Modal -->
            <div class="modal fade" id="Zakat-modal" tabindex="-1" role="dialog" aria-labelledby="Zakat-modal"
              aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <img class="banner" src="/assets/img/zakah.jpg" alt="zahah" loading="lazy" />
                    <form @submit.prevent>
                      <div class="row">
                        <div class="col-12">
                          <div class="input-area mb-30">
                            <input type="text" class="form-control zakat-calc-field mt-3"
                              :placeholder="$t('app.enterAmount')" @keypress="calculate_result = ''"
                              v-model="calculate_amount" />
                          </div>
                        </div>
                        <div class="col-12 payment-inner">
                          <button @click="calculate" class="theme_btn theme_btn_bg zakat-calc-btn">
                            {{ $t("app.calculate_zakaah") }}
                          </button>
                        </div>
                        <div v-if="calculate_result" class="col-12 zakat-calc-result">
                          {{ $t("app.amount_of_zakaah_is") }}:<br /><br />
                          <span> {{ calculate_result }}</span>
                          {{ $t("app.kwd") }}
                          <!-- <button
                            class="theme_btn theme_btn_bg zakat-calc-btn border-0  w-50 text-center mx-auto mt-10 d-block"
                          >
                            {{ $t("app.donate_Now") }}
                            <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                              ><i
                                class="fas fa-hand-holding-seedling fa-flip-horizontal"
                              ></i
                            ></span>
                          </button> -->
                          <button class="theme_btn theme_btn_bg mt-4 w-100" @click="addToCart()">
                            {{ $t("app.donate_Now") }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <!-- cart icon -->
            <!-- <div class="nav-tools-icon d-md-block">
              <router-link v-if="paymentStatus != 0" :to="'/carts'" aria-label="cart icon and count">
                <span v-if="cartCount" class="badge badge-danger badge-alert">
                  {{ cartCount }}
                </span>
                <i
                  class="far fa-shopping-cart"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  :title="$t('app.cart')"
                  :style="cartCount ? 'margin-bottom: 15px;' : ''"
                >
                </i>
              </router-link>
            </div> -->
            <!-- <div class="handle-icon"></div> -->

            <!-- Search icon -->
            <div class="main-menu nav-tools-icon d-md-block lang-icon">
              <a class="navbar-response-action" data-toggle="modal" data-target="#search-modal" href="javascript:;"
                aria-label="search icon">
                <i class="far fa-search" data-toggle="tooltip" data-placement="bottom" :title="$t('app.search')">
                </i>
              </a>
            </div>

            <!-- <div class="nav-seprator d-none d-xl-flex"></div> -->
            <div class="main-menu nav-tools-icon d-md-block lang-icon">
              <ul>
                <li class="navbar-response-action">
                  <span class="lang-selector" aria-label="user icon">
                    <i class="far fa-user"></i>
                  </span>
                  <ul class="submenu">
                    <li v-if="!isLoggedIn">
                      <router-link class="" :to="'/login'">
                        {{ $t("auth.login") }}
                      </router-link>
                    </li>
                    <li v-if="!isLoggedIn">
                      <router-link class="" :to="'/register'">
                        {{ $t("auth.register") }}
                      </router-link>
                    </li>
                    <li v-if="isLoggedIn">
                      <router-link class="" :to="'/profile'">
                        {{ $t("auth.profile") }}
                      </router-link>
                    </li>
                    <!-- <li v-if="isLoggedIn">
                      <router-link class="" :to="'/shares'">
                        {{ $t("auth.shares") }}
                      </router-link>
                    </li> -->
                    <li v-if="isLoggedIn">
                      <a href="javascript:;" class="" @click="logout()" aria-label="logout">
                        {{ $t("auth.logout") }}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div class="quote-btn">
              <a :href="donationLink || '#'" rel="noopener noreferrer" class="theme_btn theme_btn_bg">
                {{ $t("app.donate_Now") }}
                <span :style="[locale === 'en' ? { left: 'auto' } : {}]">
                  <i class="fas fa-hand-holding-seedling fa-flip-horizontal"></i>
                </span>
              </a>
            </div>

            <!-- Zakat Donations Modal -->
            <div class="modal fade donation-popup" id="donation-modal" tabindex="-1" role="dialog"
              aria-labelledby="donation-modal" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="doante-select-area donate-select-area-04 text-center white-bg wow fadeInUp2 animated"
                      data-wow-delay=".1s" style="
                        visibility: visible;
                        animation-delay: 0.1s;
                        animation-name: fadeInUp2;
                      ">
                      <div class="section-title text-left mb-45">
                        <h6>
                          <span :style="[locale == 'en' ? { left: 'auto' } : {}]"><i class="fas fa-heart"></i></span>
                          <!-- {{ $t("app.general_donation") }} -->
                          {{ $t("app.zakat_and_charity_funds") }}
                        </h6>
                        <h2>{{ $t("app.donation_values_types") }}</h2>
                      </div>
                      <div class="select-area mb-10">
                        <select name="fund" id="fund" style="display: none">
                          <option value="Select Fund">
                            {{ $t("app.donation_types") }}
                          </option>
                          <option v-for="(row, index) in types" :key="index" :value="row.name">
                            {{ row.name }}
                          </option>
                        </select>
                        <div class="nice-select" tabindex="0">
                          <span class="current">{{
                            $t("app.donation_types")
                          }}</span>
                          <ul class="list">
                            <li data-value="Select Fund" class="option selected">
                              {{ $t("app.donation_types") }}
                            </li>
                            <li class="option" v-for="(row, index) in types" :key="index" @click="changeType(row.id)"
                              :data-value="row.name">
                              {{ row.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="donate-cart pos-rel mb-10">
                        <form class="donate-btn pos-rel" action="">
                          <input type="number" min="1" class="input-donat" v-model="custom_amount"
                            :placeholder="$t('app.enter_amount')" />
                        </form>
                        <div class="plus-minus">
                          <div :style="[
                            locale == 'ar'
                              ? { right: '0px' }
                              : { left: '0px' },
                          ]" class="cart inc">
                            <i style="padding: 25px" :class="[
                              locale == 'ar'
                                ? 'far fa-chevron-right'
                                : 'far fa-chevron-left',
                            ]" @click="incrementCustomAmount()"></i>
                          </div>
                          <div :style="[
                            locale == 'ar'
                              ? { left: '0px' }
                              : { right: '0px' },
                          ]" class="cart dec">
                            <i style="padding: 25px" :class="[
                              locale == 'ar'
                                ? 'far fa-chevron-left'
                                : 'far fa-chevron-right',
                            ]" @click="decrementCustomAmount()"></i>
                          </div>
                        </div>
                      </div>
                      <div class="input-donate mb-10">
                        <button class="cont_btn" v-for="(row, index) in values" :key="index"
                          @click="changeAmount(row.id, row.amount)" :class="amount_id == row.id && !custom_amount.length
                            ? 'active'
                            : ''
                            ">
                          {{ row.amount }}

                          <span class="usd" v-if="locale == 'ar'">
                            {{ currency == "KWD" ? "د.ك" : "ريال" }}
                          </span>
                          <span class="usd" v-else>
                            {{ currency == "SAR" ? "SAR" : "KWD" }}
                          </span>
                        </button>
                      </div>
                      <button class="theme_btn theme_btn_bg mt-4" @click="addToCart()" data-dismiss="modal"
                        aria-label="Close">
                        {{ $t("app.donate_Now") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="quote-btn float_Donate position-fixed top-5" style="width: fit-content">
        <!--<a
        data-toggle="modal"
        data-target="#donation-modal"
        href="javascript:;"
        class="theme_btn theme_btn_bg text-center p-3 m-0"
        style="width: fit-content;"
        aria-label="general donation"
      >
        {{ $t("app.general_donation") }}
      </a>-->
      </div>

      <!-- class="theme_btn theme_btn-whatsapp float_Whatsapp theme_btn_bg" -->

      <div class="custom-container">
        <a :href="whatsAppNo" aria-label="whatsApp number" target="_blank" class="float_Whatsapp" style="
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background-color: #25d366;
            padding-top: 10px;
            text-align: center;
            color: #fff;
          ">
          <span :style="[locale == 'en' ? { left: 'auto' } : {}]"><i class="fab fa-whatsapp"
              style="font-size: 22px"></i></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import sendEvent from "@/helpers/sendEvent";
import { trackAddToCart } from "@/helpers/pixel";
import iziToast from "izitoast";
import $ from "jquery";

export default {
  name: "Header",
  components: {},
  data() {
    return {
      auth: {
        access_token: "",
        avatar: "",
        first_name: "",
        last_name: "",
      },
      categories: [],
      donationLink: "",
      isLoggedIn: false,

      search: "",
      isDropDown: false,
      isSideOpen: false,

      locale: "ar",
      currency: "KWD",
      pgLoading: true,
      socials: [],
      header: "",
      urgent: "",
      links: [],
      donateNow: "",
      amount: "",
      calculate_amount: "",
      calculate_result: "",
      whatsAppNo: window.whatsAppNo,

      cartCount: false,

      info: "",

      type_id: 0,
      amount_id: 1,
      custom_amount: "",

      types: [],
      values: [],

      paymentStatus: 1,
    };
  },
  mounted() {
  },
  created() {
    this.scrollToTop();

    // Auth
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
      this.isLoggedIn = true;
    }
    if (localStorage.getItem("first_name")) {
      this.auth.first_name = localStorage.getItem("first_name");
    }
    if (localStorage.getItem("last_name")) {
      this.auth.last_name = localStorage.getItem("last_name");
    }
    if (localStorage.getItem("avatar")) {
      this.auth.avatar = localStorage.getItem("avatar");
    }

    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
      this.changeDir(this.locale);
    }

    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    // set i18n local
    this.$i18n.locale = this.locale;
    this.$i18n.local = this.locale;

    this.fetchData();
    this.fetchCategories();
    this.fetchDonationLink();
    this.fetchData2();
    this.fetchPayment();
  },
  methods: {
    fetchCategories() {
      const options = {
        url: window.baseURL + "/categories",
        method: "GET",
        params: {
          locale: this.locale,
          status: "active",
        },
      };

      this.$axios(options)
        .then((res) => {
          this.categories = res.data.rows || [];
          console.log(res);
        })
        .catch(() => {
          this.categories = [];
        })
        .finally(() => { });
    },
    fetchDonationLink() {
      const options = {
        url: window.baseURL + "/dashboard/donation/link",
        method: "GET",
      };
      this.$axios(options)
        .then((res) => {
          this.donationLink = res.data.link || "#"; // ✅ التصحيح هنا
          // console.log("Donation Link:", this.donationLink);
        })
        .catch(() => {
          this.donationLink = "#";
        })
        .finally(() => { });
    },
    fetchPayment() {
      const options = {
        url: window.baseURL + "/settings/26",
        method: "GET",
      };

      this.$axios(options)
        .then((res) => {
          this.paymentStatus = res.data.status;
        })
        .catch(() => {
          this.paymentStatus = 0;
        })
        .finally(() => { });
    },
    calculate() {
      this.calculate_result = (this.calculate_amount * 2.5) / 100;
      // change the element of class zakat-calc-result to be displead
      $(".zakat-calc-result").show();
    },

    //
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    incrementCustomAmount() {
      this.custom_amount = parseInt(this.custom_amount) + 1;
    },

    decrementCustomAmount() {
      if (this.custom_amount > 1) {
        this.custom_amount = parseInt(this.custom_amount) - 1;
      }
    },
    // fetch Data
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/header",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.socials = res.data.socials;
          this.links = res.data.links;
          this.header = res.data.header;
          this.urgent = res.data.urgent;
          this.donateNow = res.data.donateNow;
          this.cartCount = res.data.cartCount;
        })
        .catch(() => { })
        .finally(() => { });
    },

    // toggle Dropdown
    toggleDropdownBar() {
      if (this.isDropDown) {
        let app = document.querySelectorAll("div.app");
        let appx = app[app.length - 1];
        appx.classList.remove("side-nav-folded");
        this.isDropDown = false;
      } else {
        let app = document.querySelectorAll("div.app");
        let appx = app[app.length - 1];
        appx.classList.add("side-nav-folded");
        this.isDropDown = true;
      }
    },

    opnTaby() {
      let app = document.querySelectorAll("nav#navbarOnMob");
      let appx = app[app.length - 1];

      let app2 = document.querySelectorAll("span.taby");
      let appx2 = app2[app2.length - 1];

      let app3 = document.querySelectorAll("p.tabyX");
      let appx3 = app3[app3.length - 1];

      if (appx.classList.contains("hidden")) {
        appx.classList.remove("hidden");
        appx2.classList.add("hidden");
        appx3.classList.remove("hidden");
      } else {
        appx.classList.add("hidden");
        appx2.classList.remove("hidden");
        appx3.classList.add("hidden");
      }
    },

    // toggle Dropdown
    toggleSideBar() {
      if (this.isSideOpen) {
        let app = document.querySelectorAll("div.app");
        let appx = app[app.length - 1];
        appx.classList.remove("quick-view-expand");
        this.isSideOpen = false;
      } else {
        let app = document.querySelectorAll("div.app");
        let appx = app[app.length - 1];
        appx.classList.add("quick-view-expand");
        this.isSideOpen = true;
      }
    },

    // isTokenValid(){
    //     const token = localStorage.getItem('accessToken');
    //     if(!token) {
    //         return false;
    //     }
    //     const { exp } = JSON.parse(atob(token.split('.')[1]));
    //     return exp > Date.now().valueOf() / 1000;
    // }

    changeLang: function (id) {
      if (id == 1) {
        this.locale = "ar";
        this.$i18n.locale = "ar";
        this.$i18n.local = "ar";
        localStorage.setItem("locale", "ar");
      } else {
        this.locale = "en";
        this.$i18n.locale = "en";
        this.$i18n.local = "en";
        localStorage.setItem("locale", "en");
      }

      this.changeDir(this.locale);
      window.location.reload();
    },

    changeCurrency(currency) {
      this.currency = currency;
      localStorage.setItem("currency", currency);
    },

    changeDir: function (lang) {
      if (lang == "ar") {
        let body = document.querySelectorAll("body");
        let app = body[body.length - 1];
        app.classList.remove("ltr");
        app.classList.add("rtl");
      } else {
        let body = document.querySelectorAll("body");
        let app = body[body.length - 1];
        app.classList.add("ltr");
        app.classList.remove("rtl");
      }
    },

    logout() {
      this.logoutToken();
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");

      this.$router.push({ name: "home" });
      window.location.reload();
    },

    logoutToken() {
      // this.axios.defaults.headers.common = {
      //   "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      //   Authorization: `Bearer ` + this.auth.access_token,
      // };
      const options = {
        url: window.baseURL + "/auth/logout",
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Authorization: `Bearer ` + this.auth.access_token,
        },
        data: {},
      };
      this.$axios(options)
        .then(() => { })
        .catch(() => { })
        .finally(() => {
          localStorage.removeItem("access_token");
          localStorage.removeItem("user_image");
          localStorage.removeItem("first_name");
          localStorage.removeItem("last_name");
          localStorage.removeItem("user_id");
          localStorage.removeItem("email");
          localStorage.removeItem("id_number");

          this.$router.push({ name: "home" });
        });
    },

    //
    fetchData2() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/settings/1",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          //this.pgLoading = false;
          this.info = res.data.info;
          this.fetchDonationsValues();
        })
        .catch(() => { })
        .finally(() => { });
    },

    fetchDonationsValues() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/donations/values",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
        },
      };
      this.$axios(options)
        .then((res) => {
          //this.pgLoading = false;
          this.values = res.data.rows;
          this.amount_id = res.data.rows[0].id;
          this.amount = res.data.rows[0].amount;

          this.fetchDonationsTypes();
        })
        .catch(() => { })
        .finally(() => { });
    },

    fetchDonationsTypes() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/donations/types",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          currency: this.currency,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.types = res.data.rows;
          this.type_id = res.data.rows[0].id;
        })
        .catch(() => { })
        .finally(() => { });
    },

    // addToCart
    addToCart() {
      // paymentStatus
      if (this.paymentStatus == 0) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.payment_status_error"),
        });
        return false;
      }
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      let amount_total = this.amount;
      if (Number(this.custom_amount) >= 1) {
        amount_total = this.custom_amount;
      }
      if (this.calculate_result >= 1) {
        amount_total = this.calculate_result;
      }
      const options = {
        url: window.baseURL + "/carts",
        method: "POST",
        data: {
          model_id: "",
          model_type: "",
          type_id: this.type_id,
          amount: amount_total,
        },
        params: {},
      };
      this.$axios(options)
        .then(() => {
          this.btnLoading = false;
          sendEvent("AddToCart", amount_total);
          trackAddToCart({
            value: amount_total,
            currency: "KWD",
            content_ids: this.type_id ? [this.type_id] : [],
            content_type: "general_donation",
          });
          iziToast.success({
            icon: "ti-check",
            title: "",
            message: this.$t("app.add_msg"),
          });

          if (this.$route.path == "/carts") {
            this.$router.go(this.$router.currentRoute);
          } else {
            this.$router.push({ name: "carts" });
          }
        })
        .catch((err) => {
          this.btnLoading = false;
          if (err.response && err.response.status == 401) {
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          } else {
            iziToast.warning({
              icon: "ti-alert",
              title: "",
              message: err.response ? this.$t("app.add_fail") : "" + err,
            });
          }
        })
        .finally(() => { });
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    changeAmount: function (id, amount) {
      this.amount = amount;
      this.amount_id = id;
      this.custom_amount = "";
    },

    changeType: function (id) {
      this.type_id = id;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.x-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: -0.125em;
}

ul.submenu li>a.active {
  color: #f8327d !important;
}

.nav-items {
  display: flex;
}

.logo {
  /* position: absolute;
  top: 59px;
  z-index: 100;
  left: 50%;
  transform: translateX(-50%) !important; */
  width: 90px;
  display: flex;
  align-items: center;
  margin-inline-end: 10px;
}

.nav-icon-section {
  padding-block: 25px !important;
  justify-content: flex-end !important;
  gap: 10px;
}

.col-11 {
  padding-left: 0px !important;
}

.ltr .col-11 {
  padding-right: 0px !important;
}

.main-header-area {
  position: unset !important;
}

@media (min-width: 1200px) {
  .nav-icon-section {
    padding-block: 14px !important;
  }

  .ltr .text-xl-right {
    text-align: left !important;
  }
}

@media (min-width: 1600px) {
  .rtl .main-menu ul li {
    margin-left: 15px;
  }

  .ltr .main-menu ul li {
    margin-left: 15px;
  }
}

@media (min-width: 1200px) and (max-width: 1600px) {
  .main-menu nav ul {
    /* width: 460px !important; */
  }
}

@media (max-width: 1199.98px) {
  .logo {
    min-width: 55px;
  }
}

@media all and (max-width: 767px) {
  .rtl .main-header-area .logo-img img {
    width: 110px;
  }

  .ltr .main-header-area .logo-img img {
    width: 110px;
  }

  .logo-holder {
    margin-top: 23px;
  }

  .handle-icon {
    width: 300px !important;
  }

  .col-10,
  .col-lg-3,
  .col-md-3,
  .col-xl-3 {
    padding-left: 0 !important;
  }

  .ltr .col-10,
  .ltr .col-lg-3,
  .ltr .col-md-3,
  .ltr .col-xl-3 {
    padding-right: 0 !important;
  }

  .nav-icon-section {
    display: inline-block;
  }

  .quote-btn {
    min-width: auto !important;

  }

  .nav-icon-section {
    display: flex;
  }

  div .quote-btn a {
    padding: 17px 19px 17px 20px !important;
    width: 45px !important;
    min-width: 45px !important;
    max-width: 45px !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    display: inline-block !important;
    line-height: 1 !important;
  }

  div .quote-btn a span {
    width: 100% !important;
    height: 100% !important;
    top: 0 !important;
    left: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #f8327d !important;
  }

  div .quote-btn a span i {
    color: #fff !important;
  }

  .navbar-response-action {
    width: 45px !important;
    min-width: 45px !important;
    max-width: 45px !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
}

.custom-container {
  width: 90%;
  margin: 0 auto;
}

.quote-btn {
  min-width: 149px;
  display: flex;
  justify-content: center;
}

.quote-btn a {
  padding-inline-end: 37%;
  width: 100%;
  text-align: start;
}

@media all and (min-width: 1280px) {
  .quote-btn {
    display: flex !important;
  }
}

.float_Donate {
  position: fixed;
  bottom: 30px;
  z-index: 1000;
  right: 2%;
}

.float_Whatsapp {
  position: fixed;
  z-index: 100000;
  inset-inline-start: 15px !important;
  bottom: 33px;
}

@media all and (min-width: 1200px) and (max-width: 1600px) {

  .projectsProgress,
  .submenu.projectsProgress,
  .submenu.about {
    width: 180px !important;
  }
}

@media (max-width: 1199.98px) {
  .header-top-area2 .top-right-nav ul {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .header-top-area2 .top-right-nav ul li {
    margin: 0;
  }
}

@media (max-width: 991.98px) {
  .header-top-area2 > .custom-container {
    width: 100%;
    padding-inline: 16px;
  }

  .header-top-area2 > .custom-container > .row {
    flex-wrap: nowrap;
    gap: 12px;
    margin-inline: 0;
  }

  .header-top-area2 .top-bar-socials,
  .header-top-area2 .top-bar-message,
  .header-top-area2 .top-bar-language {
    width: auto;
    max-width: none;
    padding-inline: 0 !important;
  }

  .header-top-area2 .top-bar-socials,
  .header-top-area2 .top-bar-language {
    flex: 0 0 auto;
  }

  .header-top-area2 .top-bar-message {
    flex: 1 1 0;
    min-width: 0;
  }

  .header-top-area2 .lang-icon ul.submenu {
    inset-inline-end: 0;
    inset-inline-start: auto;
  }
}

@media (max-width: 767.98px) {
  .header-top-area2 > .custom-container {
    padding-inline: 12px;
  }

  .header-top-area2 > .custom-container > .row,
  .header-top-area2 .top-right-nav ul {
    gap: 8px;
  }

  .header-top-area2 .top-right-nav ul li a {
    font-size: 14px;
  }

  .header-top-area2 .top-bar-message > a {
    font-size: clamp(12px, 3.2vw, 14px);
    line-height: 1.5;
  }
}
</style>
